import { render, staticRenderFns } from "./Trashbin.vue?vue&type=template&id=d8a8cd2e&scoped=true&"
import script from "./Trashbin.vue?vue&type=script&lang=js&"
export * from "./Trashbin.vue?vue&type=script&lang=js&"
import style0 from "./Trashbin.vue?vue&type=style&index=0&id=d8a8cd2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a8cd2e",
  null
  
)

export default component.exports